<script setup>
const euFlagSrc = `${import.meta.env.BASE_URL}images/eu-flag.jpg`;
</script>

<template>
    <div class="layout-footer">
        <div class="flex-[0_0_75px]">
            <Image :src="euFlagSrc" alt="EU Flag" class="w-full h-full object-contain" />
        </div>
        <div class="text-sm">This project has received funding from the European Union’s Horizon Europe framework
            programme under grant agreement No.101073909.<br />The contents of this website represent the views of the authors only and remain
            their sole responsibility. The European Research Executive Agency (REA) and the European Commission are not
            responsible for any use of the included information.</div>

    </div>
</template>
